import React from "react";
import Site from "./site/Site";

function App() {
  return <Site />;
}

export default App;
